/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} My_ProfileInputs */

const en_my_profile = /** @type {(inputs: My_ProfileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`My profile`)
};

const nl_my_profile = /** @type {(inputs: My_ProfileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mijn profiel`)
};

/**
* | output |
* | --- |
* | "My profile" |
*
* @param {My_ProfileInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const my_profile = /** @type {((inputs?: My_ProfileInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<My_ProfileInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_my_profile(inputs)
	return en_my_profile(inputs)
});